<template>
    <div class="resume-page-wrapper">
        <Cvs v-if="activeSection == 1" @switchSection="switchSection"></Cvs>
        <CvsTemplate v-if="activeSection == 2" @switchSection="switchSection" :payload="editorPayload"
            @resetEditorPayload="editorPayload = null"></CvsTemplate>
    </div>
</template>
  
<script>
import Cvs from "./cvsAndTemplateManager.vue";
import CvsTemplate from "./templateEditor.vue";
export default {
    name: "resume-page",
    components: {
        Cvs,
        CvsTemplate
    },
    data() {
        return {
            activeSection: 1,
            editorPayload: null,
            templateAllowedVersion: "1.3"
        };
    },
    mounted() {
        let vm = this;
        window.addEventListener(
            "message",
            (event) => {
                const message = event.data.message;
                switch (message) {
                    case "checkToHideChat":
                        if (vm.activeSection == 2) {
                            window.parent.postMessage(
                                { message: "switchChat", value: { data: false } },
                                "*"
                            );
                        } else {
                            window.parent.postMessage(
                                { message: "switchChat", value: { data: true } },
                                "*"
                            );
                        }
                        break;
                }
            },
            false
        );
    },
    methods: {
        switchSection(selectedSection, payload = null) {
            let vm = this;
            vm.editorPayload = payload;
            vm.activeSection = selectedSection;
        },
    },
};
</script>
<style lang="scss" scoped>
.resume-page-wrapper {
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    padding-top: 56px;
}
</style>